"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldType = void 0;
/**
 * SharePoint property pane group field type.
 */
var FieldType;
(function (FieldType) {
    /**
     * Checkbox field.
     */
    FieldType[FieldType["CheckBox"] = 2] = "CheckBox";
    /**
     * Text field.
     */
    FieldType[FieldType["TextField"] = 3] = "TextField";
    /**
     * Toggle field.
     */
    FieldType[FieldType["Toggle"] = 5] = "Toggle";
    /**
     * Dropdown field.
     */
    FieldType[FieldType["Dropdown"] = 6] = "Dropdown";
    /**
     * Label field.
     */
    FieldType[FieldType["Label"] = 7] = "Label";
    /**
     * Slider field.
     */
    FieldType[FieldType["Slider"] = 8] = "Slider";
    /**
     * Choice Group field.
     */
    FieldType[FieldType["ChoiceGroup"] = 10] = "ChoiceGroup";
    /**
     * Horizontal Rule field.
     */
    FieldType[FieldType["HorizontalRule"] = 12] = "HorizontalRule";
    /**
     * Link field.
     */
    FieldType[FieldType["Link"] = 13] = "Link";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
//# sourceMappingURL=propertyPaneGroupField.js.map